function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeWidth: 0.896
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.406 13.627c-2.193 0-3.862.214-5.063.28A6.868 6.868 0 0017.5 18.59c0 3.837 3.134 6.948 7 6.948s7-3.11 7-6.948c0-1.772-.682-3.364-1.782-4.59-1.221-.06-2.992-.373-5.312-.373z",
  transform: "matrix(1.1159 0 0 1.1157 -1.33 .83)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.688 23.625C15.168 25.494 12 29.93 12 35.094c0 3.244 1.26 6.196 3.313 8.406h.187c3.038 0 5.5.896 5.5 2 0 .433-.389.83-1.03 1.156a12.575 12.575 0 008.812.094c-.483-.343-.782-.776-.782-1.25 0-1.104 1.567-2 3.5-2 .699 0 1.36.111 1.907.313A12.335 12.335 0 0037 35.093c0-5.163-3.167-9.6-7.687-11.468-1.256 1.187-2.942 1.906-4.813 1.906s-3.556-.72-4.812-1.906zM31.4 13.627c-.723.83-3.134 0-7 0s-6.134.681-7 0c-1.334-1.05-.297-3.898 7-3.97 6.468-.065 7.956 2.874 7 3.97z",
  transform: "matrix(1.1159 0 0 1.1157 -1.33 .83)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M27.469.5C25.893.44 24.243.849 23 1.719c-2.394 1.676-4.262 7.454-4.781 9.187 1.14-.677 3.1-1.219 6.188-1.25 3.2-.032 5.18.68 6.25 1.531-.734-1.185-2.55-4.352-1.657-5.5.911-1.171 3.265-.743 5.188-.125.153-.374.384-.71.687-.968C33.201 3.059 30.861 1.169 29 .719A7.767 7.767 0 0027.47.5zM20.3 21.27c1.7 1.686 3.553 2.514 6 0M23.001 18.59l-2.701.993c1.907.382 3.551.584 4.051 0 .413-1.203-.433-1.134-1.35-.993z",
  transform: "matrix(1.1159 0 0 1.1157 -1.33 .83)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.1159 0 0 1.1157 -1.33 .83)"
}, /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1 0 0 .5 0 8.597)",
  cx: 26.5,
  cy: 17,
  rx: 0.5,
  ry: 1,
  strokeWidth: 1.267
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1 0 0 .5 -5.5 8.397)",
  cx: 26.5,
  cy: 17,
  rx: 0.5,
  ry: 1,
  strokeWidth: 1.267
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 45.5c0 1.105-2.462 2-5.5 2s-5.5-.895-5.5-2 2.462-2 5.5-2 5.5.895 5.5 2z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "translate(0 -.5)",
  cx: 31.5,
  cy: 46,
  rx: 3.5,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-2 -2)",
  cx: 38.5,
  cy: 8.5,
  r: 2.5
})));

var SvgSnowman = function SvgSnowman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnowman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Snowman.b2328485.svg";
export { ForwardRef as ReactComponent };